import { Resource } from "react-admin";
import Work from "@material-ui/icons/Work";
import React from "react";

import List from "./List";
import Show from "./Show";
import Create from "./Create";
import Edit from "./Edit";
import PermissionDenied from "../../components/PermissionDenied";
import { POLICY_COMPANIES } from "../../common/rolesManagement";

export default permissions => (
    <Resource
        name="companies"
        icon={Work}
        list={
            permissions && permissions.includes(POLICY_COMPANIES.READ)
                ? List
                : PermissionDenied
        }
        show={
            permissions && permissions.includes(POLICY_COMPANIES.READ)
                ? Show
                : PermissionDenied
        }
        create={
            permissions &&
            (permissions.includes(POLICY_COMPANIES.CREATE) ||
                permissions.includes(POLICY_COMPANIES.SAFE_CREATE))
                ? Create
                : PermissionDenied
        }
        edit={
            permissions &&
            (permissions.includes(POLICY_COMPANIES.UPDATE) ||
                permissions.includes(POLICY_COMPANIES.UPDATE_SLAVE_ONLY))
                ? Edit
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/Companies/index.js